document.addEventListener('DOMContentLoaded', function () {
	// TODO: Change this to querySelectorAll and then loop through all of the elements
	var calendars = document.querySelectorAll('.simcal-fullcalendar-grid .simcal-fullcal');

	calendars.forEach(function (calendarElement) {
		var bubbleTrigger = calendarElement.getAttribute('data-event-bubble-trigger') === 'hover' ? 'mouseenter' : 'click';
		var defaultView = calendarElement.getAttribute('data-default-view');
		if (defaultView === 'month') {
			defaultView = 'dayGridMonth';
		} else if (defaultView === 'agendaWeek') {
			defaultView = 'timeGridWeek';
		} else {
			defaultView = 'timeGridDay';
		}

		var dayGridMonth = calendarElement.getAttribute('data-month-button') ? 'dayGridMonth ' : '';
		var timeGridWeek = calendarElement.getAttribute('data-week-button') ? 'timeGridWeek ' : '';
		var timeGridDay = calendarElement.getAttribute('data-day-button') ? 'timeGridDay' : '';

		var pagingButtons = calendarElement.getAttribute('data-paging-buttons');
		pagingButtons = pagingButtons === '" ' ? '' : pagingButtons;

		var timeFormat = {
			hour: calendarElement.getAttribute('data-date-format-hour'),
			minute:
				calendarElement.getAttribute('data-date-format-minute') === 'none'
					? '2-digit'
					: calendarElement.getAttribute('data-date-format-minute'),
			hour12: calendarElement.getAttribute('data-date-format-hour12') === '12hour' ? true : false,
			omitZeroMinute: calendarElement.getAttribute('data-date-format-minute') === 'none' ? true : false,
		};

		// Add meridiem
		if (calendarElement.getAttribute('data-date-format-meridiem') !== 'uppercase') {
			if (calendarElement.getAttribute('data-date-format-meridiem') === 'none') {
				timeFormat.meridiem = false;
			} else {
				timeFormat.meridiem = calendarElement.getAttribute('data-date-format-meridiem');
			}
		}

		var eventLimitAttr = calendarElement.getAttribute('data-event-limit');
		var dayMaxEvents = window.matchMedia('(max-width: 767px)').matches ? 1 : true;

		if (eventLimitAttr && eventLimitAttr !== 'false') {
			var parsedEventLimit = parseInt(eventLimitAttr, 10);

			if (!isNaN(parsedEventLimit) && parsedEventLimit > 0) {
				dayMaxEvents = parsedEventLimit;
			}
		}

		var calendarHeightAttr = calendarElement.getAttribute('data-calendar-height');

		var calendarOptions = {
			eventDisplay: 'block',
			eventOrder: 'start,calendar_priority,-duration,allDay,title',
			initialView: defaultView,
			firstDay: calendarElement.getAttribute('data-week-starts'),
			fixedWeekCount: false,
			initialDate: calendarElement.getAttribute('data-start'),
			validRange: {
				start: calendarElement.getAttribute('data-earliest'),
				end: calendarElement.getAttribute('data-latest'),
			},
			dayMaxEvents: dayMaxEvents,
			moreLinkText: function (num) {
				return '+' + num;
			},
			eventColor: calendarElement.getAttribute('data-event-color'),
			eventTextColor: calendarElement.getAttribute('data-text-color'),
			scrollTime: calendarElement.getAttribute('data-default-start-time'),
			slotMinTime: calendarElement.getAttribute('data-display-min-time'),
			slotMaxTime: calendarElement.getAttribute('data-display-max-time'),
			locale: calendarElement.getAttribute('data-display-language'),
			eventTimeFormat: timeFormat,
			headerToolbar: {
				start:
					pagingButtons +
					(calendarElement.getAttribute('data-today-button')
						? (' ' + calendarElement.getAttribute('data-today-button')).trim()
						: ''),
				center: 'title',
				end: (dayGridMonth + timeGridWeek + timeGridDay).trim(),
			},

			timeZone: calendarElement.getAttribute('data-timezone'),
			events: {
				url: simcal_fullcal.settings.ajax_url,
				method: 'POST',
				extraParams: {
					action: 'simcal_fullcal_load_events',
					calendar_id: calendarElement.getAttribute('data-calendar-id'),
				},
				failure: function (response) {
					console.log('Error loading events', response);
				},
			},
			eventClick: function (info) {
				info.jsEvent.preventDefault();
			},
			eventDidMount: function (info) {
				var qtipId = info.event.extendedProps.qtip_id;
				if (qtipId) {
					info.el.setAttribute('data-simcal-qtip', qtipId);
				}
			},
		};

		if (calendarHeightAttr === 'auto') {
			calendarOptions.height = 'auto';
		} else {
			var parsedCalendarHeight = parseInt(calendarHeightAttr, 10);

			if (!isNaN(parsedCalendarHeight) && parsedCalendarHeight > 0) {
				calendarOptions.height = parsedCalendarHeight;
			} else {
				calendarOptions.aspectRatio = 1.35;
			}
		}

		calendarOptions.views = {
			dayGridMonth: {
				dayHeaderFormat: { weekday: 'short' },
			},
			timeGridWeek: {
				dayMaxEventRows: dayMaxEvents,
				dayHeaderFormat: { weekday: 'short', month: 'numeric', day: 'numeric', omitCommas: true },
			},
			timeGridDay: {
				dayMaxEventRows: dayMaxEvents,
			},
		};

		var calendar = new FullCalendar.Calendar(calendarElement, calendarOptions);
		calendar.render();

		calendarElement.addEventListener(bubbleTrigger === 'mouseenter' ? 'mouseover' : 'click', function (event) {
			var eventEl = event.target.closest && event.target.closest('.fc-event');
			if (!eventEl || !calendarElement.contains(eventEl) || eventEl._tippy || typeof tippy !== 'function') {
				return;
			}

			var qtipId = eventEl.getAttribute('data-simcal-qtip');
			var contentEl = qtipId && document.querySelector('.simcal-fullcal-qtip-id-' + qtipId);
			if (!contentEl || !contentEl.innerHTML) {
				return;
			}

			if (bubbleTrigger === 'click') {
				event.preventDefault();
				event.stopPropagation();
			}

			// Defer show so the same tap does not immediately hide the bubble.
			var instance = tippy(eventEl, {
				allowHTML: true,
				content: contentEl.innerHTML,
				theme: 'light',
				interactive: true,
				trigger: bubbleTrigger,
				appendTo: document.body,
				onMount: function (tip) {
					var box = tip.popper.querySelector('.tippy-box');
					if (box) {
						box.classList.add('simcal-fullcal-tippy-box');
					}

					tip.popper.addEventListener('mousedown', function (e) {
						e.stopPropagation();
					});
				},
			});

			setTimeout(function () {
				if (instance && !instance.state.isDestroyed) {
					instance.show();
				}
			}, 0);
		});
	});
});
